import { Navigate } from "react-router-dom";
import LoginForm from "../login/Form";
import NNPClogo from "../../assets/NNPC LOGO PRIMARY WHITE 1.png";
import banner from "../../assets/images/003.jpg";
import "../../index.css";
import useAuth from "../../hooks/useAuth";

export default function Login() {
  const { auth } = useAuth();

  if (auth?.staff_id) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <div className="grid w-full h-screen grid-cols-1 md:grid-cols-2 xl:grid-cols-3 overflow-hidden font-Montserrat bg-white">
      {/* Left Banner Section */}
      <div className="hidden md:flex relative w-full h-full md:col-span-1 xl:col-span-2">
        <img
          src={banner}
          alt="NNPC Internship Banner"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/50 to-[#226845]/70"></div>

        <div className="absolute inset-0 flex flex-col items-center justify-center text-center text-white px-8">
          <h1 className="text-2xl md:text-3xl font-semibold tracking-wide">
            NNPC Limited Internship Programme
          </h1>

          <div className="relative w-20 h-[3px] mt-4 mb-2 rounded-md overflow-hidden">
            <div className="absolute inset-0 bg-[#d4af37] animate-shimmer"></div>
          </div>

          <p className="text-gray-300 mt-3 text-sm md:text-base max-w-md leading-relaxed">
            Empowering the next generation through practical exposure and
            real-world learning opportunities.
          </p>
        </div>
      </div>

      {/* Right Section */}
      <div className="flex flex-col justify-center items-center px-6 sm:px-10 lg:px-20">
        <div className="flex justify-center mb-6">
          <img src={NNPClogo} alt="NNPC Logo" className="h-[68px] w-auto" />
        </div>

        <h2 className="text-2xl md:text-2xl font-semibold text-[#242424] mb-2 text-center">
          Internship Approval Portal
        </h2>
        <p className="text-[#A8A8A8] text-sm md:text-base text-center mb-6">
          Please sign in with your official NNPC credentials.
        </p>

        <LoginForm />
      </div>
    </div>
  );
}
